import { useState, useRef, useCallback } from 'react'

function useRefState<T>(initVal: T): [T, (val: T) => void, any] {
  const [state, setState] = useState<T>(initVal)
  const stateRef = useRef<T>(state)
  stateRef.current = state

  const updateState = useCallback((val: T) => {
    stateRef.current = val
    setState(val)
  }, [setState])

  return [
    state,
    updateState,
    stateRef,
  ]
}

export default useRefState
